"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var InputSwitchButton_1 = __importDefault(require("@l2p/ui-components/src/Inputs/InputSwitchButton"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var TableWithCollapse_1 = require("./TableWithCollapse");
var MobileRow_1 = __importDefault(require("./TableWithCollapse/MobileRow"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useFilteredData_1 = require("./useFilteredData");
var useMobileData_1 = require("./useMobileData");
var useTableData_1 = require("./useTableData");
var AllBonusesHistory = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var _a = (0, swr_hooks_1.useBonusesHistory)(currentCurrency), bonusesHistory = _a.data, isLoadingBonusesHistory = _a.isLoading;
    var _b = (0, swr_hooks_1.useFreespinsHistory)(), freespinsHistory = _b.data, isLoadingFreespinsHistory = _b.isLoading;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var OPTION_ALL = (0, react_1.useMemo)(function () { return ({ label: t('all'), value: 'all' }); }, [t]);
    var _c = (0, react_1.useState)(false), mounted = _c[0], setMounted = _c[1];
    var _d = (0, react_1.useState)({ from: undefined, to: undefined }), dates = _d[0], setDates = _d[1];
    var _e = (0, react_1.useState)(OPTION_ALL), status = _e[0], setStatus = _e[1];
    var _f = (0, react_1.useState)(OPTION_ALL), type = _f[0], setType = _f[1];
    var allData = (0, react_1.useMemo)(function () {
        var freespins = (freespinsHistory || []).map(function (item) { return (__assign(__assign({}, item), { type: apps_shared_1.BonusTypes.FREESPINS })); });
        var bonuses = (bonusesHistory || []).map(function (item) { return (__assign(__assign({}, item), { type: apps_shared_1.BonusTypes.BONUSES })); });
        return __spreadArray(__spreadArray([], bonuses, true), freespins, true);
    }, [bonusesHistory, freespinsHistory]);
    var filteredData = (0, useFilteredData_1.useFilteredData)({
        data: allData || [],
        dates: dates,
        status: status,
        type: type,
    });
    var statusOptions = (0, apps_shared_1.useGenerateBonusStatuses)();
    var bonusTypes = (0, apps_shared_1.useGenerateBonusTypes)();
    var tableData = (0, useTableData_1.useTableData)(filteredData);
    var mobileTableData = (0, useMobileData_1.useMobileData)(filteredData);
    var onDateFilterChange = (0, react_1.useCallback)(function (dates) { return setDates(dates); }, []);
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (isLoadingBonusesHistory || isLoadingFreespinsHistory)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        Object.keys(breakpoints).length > 0 && !breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainer },
                react_1.default.createElement(InputSwitchButton_1.default, { options: __spreadArray([OPTION_ALL], bonusTypes, true), value: type, onChange: function (value) { return setType(value); } }),
                react_1.default.createElement(ui_components_1.InputSelectSecondary, { inputName: "status", options: __spreadArray([OPTION_ALL], statusOptions, true), value: status, onChange: function (value) { return setStatus(value); }, isSearchable: false })),
            react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates }))),
        Object.keys(breakpoints).length > 0 && breakpoints.mobile && (react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersWrapper },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.filtersContainerMobile },
                react_1.default.createElement(ui_components_1.InputSelectSecondary, { inputName: "status", options: __spreadArray([OPTION_ALL], statusOptions, true), value: status, onChange: function (value) { return setStatus(value); }, isSearchable: false }),
                react_1.default.createElement(ui_components_1.DatePickerRangeWithIcon, { onChange: onDateFilterChange, values: dates })),
            react_1.default.createElement(InputSwitchButton_1.default, { options: __spreadArray([OPTION_ALL], bonusTypes, true), value: type, onChange: function (value) { return setType(value); } }))),
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && react_1.default.createElement(TableWithCollapse_1.TableWithCollapse, { data: tableData }),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("br", null),
            react_1.default.createElement(ui_components_1.MobileDataTable, { data: mobileTableData, rowComponent: MobileRow_1.default })))));
};
exports.default = AllBonusesHistory;
